import React from "react";
import { useAuth } from "auth/use-auth";
import { Nav } from "react-bootstrap";
import { MdExitToApp, MdAccountBox } from "react-icons/md";
function NavbarUser({ ...rest }) {
    // Get auth state and re-render anytime it changes
    const auth = useAuth();

    if (auth.user) {
        return (
            <Nav {...rest}>
                <Nav.Link href="/account">
                    <MdAccountBox size={24} />
                    {auth.user.firstName} {auth.user.lastName}
                </Nav.Link>
                <Nav.Link onClick={() => auth.signout()}>
                    <MdExitToApp size={24} className="text-danger" />
                </Nav.Link>
            </Nav>
        );
    } else {
        return (
            <Nav>
                <Nav.Link eventKey={2} href="/login">
                    Signin
                </Nav.Link>
            </Nav>
        );
    }
}

export default NavbarUser;
